import { Component, Input, OnInit } from '@angular/core';
import { Estacao } from '../../models/estacao.model';

@Component({
  selector: 'app-clima',
  templateUrl: './clima.component.html',
  styleUrls: ['./clima.component.scss'],
})
export class ClimaComponent implements OnInit {

  @Input() isEscuro: boolean;
  @Input() estacao: Estacao;

  constructor() { }

  ngOnInit() {
  }

}
